<template>
    <div class="modal fade" id="modal_affected_to_club" tabindex="-1" data-bs-backdrop='static' aria-hidden="true">
        <div class="modal-dialog modal-lg">
            <div class="modal-content position-relative">
                <loader-gif v-if="isRequestUser" />
                <div class="modal-header">
                    <h5 class="modal-title" id="varyingModalLabel">
                        {{ i18n.t('layout.navbar.modal.user.affected_to_club')  }}

                    </h5>
                    <button @click="closeModal('modal_affected_to_club', 'add')" type="button" class="btn-close"
                        aria-label="btn-close"></button>
                </div>
                <div class="modal-body" v-if="user">

                    <div class="row">
                        <div class="col-md-12 mb-3" >
                            <div class="row">
                                
                                <div v-if="user?.firstName || user?.lastName" class="col-md-6 mb-2 mt-2">
                                    <p class="timeline-content"><b class="d-inline-block w-160"> {{
                                        i18n.t('tables.members.name') }} </b>:
                                        {{ user?.firstName ?? '' }} {{ user?.lastName ?? '' }} </p>
                                </div>
                                <div v-if="user?.email" class="col-md-6 mb-2 mt-2">
                                    <p class="timeline-content"><b class="d-inline-block w-160">{{
                                        i18n.t('tables.members.email') }}
                                        </b>:
                                        {{ user?.email }} </p>
                                </div> 
                            </div>

                        </div>
                    </div>

                    <table id="data-users" class="datatables table table-striped table-bordered  ">
                        <thead class="thead-dark">
                            <tr>
                                <th>
                                    Club
                                </th>
                                <th>
                                    {{ i18n.t('tables.action') }}
                                </th>
                            </tr>
                        </thead>

                        <tbody>
                            <tr v-for="(club, indexClub) in user?.clubs_user" v-bind:key="club?.club?.id">
                                <td style="width: 70%;">
                                    <span>
                                        {{ club?.club?.name }}


                                    </span>
                                </td>
                                <td>
                                    <button class="active_btn active_btn-border-right-none"
                                        :class="{ 'bg-green': club.is_active }"
                                        @click="eventChangeStatus(club?.is_active ? 'true' : 'false', 'true', user?.uuid ?? '', club?.club?.uuid)">
                                        {{ i18n.t("button.enable") }}

                                    </button>
                                    <button class="active_btn active_btn-border-left-none"
                                        :class="{ 'bg-red': !club.is_active }"
                                        @click="eventChangeStatus(club?.is_active ? 'true' : 'false', 'false', user?.uuid ?? '', club?.club?.uuid)">
                                        {{ i18n.t("button.disable") }}
                                    </button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>

</template>

<script lang="ts">

import Swal from "sweetalert2";
import i18n from "@/i18n/index"
import { defineComponent, watch, toRefs } from "vue";
/*Components*/

/*composables & states */
import { useModal } from '@/composables/modal/useModal';
import { useUser } from "@/composables/auth/useUser";


export default defineComponent({
    components: {

    },
    name: "component-inscription",
    props: {
        user: {
            type: Object,
            default: null,
        },
    },
    setup(props) {
        const APP_URL = process.env.VUE_APP_URL;
        const { user } = toRefs(props);
        const { closeModal } = useModal();


        watch(
            () => user.value,
            () => {

            });



        const { changeStatus, isRequestUser } = useUser();

        const eventChangeStatus = (currentStatus: string, status: string, userUUID: string, clubUUID: string) => {

            if (currentStatus != status) {
                Swal.fire({
                    title: i18n.t("message.confirmation.edit.title"),
                    icon: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#3085d6",
                    cancelButtonColor: "#d33",
                    confirmButtonText: i18n.t("button.edit"),
                    cancelButtonText: i18n.t("button.cancel"),
                    allowOutsideClick: false,   // ✅ disable closing by clicking outside
                  allowEscapeKey: false       // (optional) disable closing with ESC
                }).then(async (result) => {
                    if (result.isConfirmed) {
                        const body = {
                            "userUUID": userUUID,
                            "clubUUID": clubUUID,
                            "is_active": status
                        }
                        changeStatus(body)
                    }
                });
            }

        }

        const emptyState = () => {

        };




        return {
            /**
             * States
             */
            eventChangeStatus,
            emptyState,

            i18n,
            APP_URL,
            closeModal,
            isRequestUser
        };
    },
});
</script>

<style lang="scss"></style>